// extracted by mini-css-extract-plugin
export default {"grid":"grid-area-module--grid--ub-Vm","animate":"grid-area-module--animate--1Z_zO","fadeOutIn":"grid-area-module--fadeOutIn--ggrDh"};